import * as React from "react";

import { Section } from "@/components/Section";
import { Container } from "@/components/Container";
import { Aurora } from "@/components/Aurora";

export function PagePlaceholder({
  title,
  intro,
  children,
}: {
  title: string;
  intro: string;
  children?: React.ReactNode;
}) {
  return (
    <Section tone="paper" className="relative overflow-hidden">
      <Aurora variant="light" className="opacity-70" />
      <Container className="relative">
        <h1 className="max-w-[18ch] font-display text-display-lg text-ink-900">{title}</h1>
        <p className="mt-6 max-w-[60ch] text-body-lg text-ink-600">{intro}</p>
        {children}
      </Container>
    </Section>
  );
}

export default PagePlaceholder;

